import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "../../plugins/gatsby-plugin-atollon";
import BlockRenderer from "../components/structured-text/block-renderer";
import { DraftDebug } from "../../plugins/gatsby-plugin-atollon";
import ProductContent from "../components/product/content";
import ProductRecipes from "../components/product/recipes";
import ProductRelated from "../components/product/related";
import ProductCta from "../components/product/cta"

const EdlynProduct = ({ pageContext, data }) => {

  let seoTags = data?.datoCmsEdlynProduct?.seoMetaTags

  const tags = seoTags.tags.map(tag => {
    if (tag.tagName === 'title') {
      tag.content = `${data?.datoCmsEdlynProduct?.title} Bulk Online | Edlyn Foods`;
    }
    if (tag.tagName === 'meta') {
      if (tag.attributes.property === 'og:title' || tag.attributes.name === 'twitter:title') {
        tag.attributes.content = `${data?.datoCmsEdlynProduct?.title} Bulk Online | Edlyn Foods`;
      }
      if (tag.attributes.property === 'og:description' || tag.attributes.name === 'twitter:description') {
        tag.attributes.content = `Bulk order ${data?.datoCmsEdlynProduct?.title}. Edlyn Foods supports the food service industry.`;
      }
      if (tag.attributes.name === 'description') {
        tag.attributes.content = `Bulk order ${data?.datoCmsEdlynProduct?.title}. Edlyn Foods supports the food service industry.`;
      }
    }
    return tag;
  });

  let updatedSeoMetaTags = { tags: tags }

  return (
    <>
      <DraftDebug publishedAt={data?.datoCmsEdlynProduct?.meta?.publishedAt} />
      <HelmetDatoCms seo={updatedSeoMetaTags} />
      <ProductContent {...data?.datoCmsEdlynProduct} form={data?.productForm} />
      <BlockRenderer data={data?.datoCmsEdlynProduct?.blocks} brand={`edlyn`} />
      <ProductRecipes brand={`edlyn`} originalId={data?.datoCmsEdlynProduct.originalId} />
      <ProductRelated related={data?.datoCmsEdlynProduct?.related} brand={`edlyn`} />
      <ProductCta cta={data?.productCta} />
    </>
  )
}

export const query = graphql`   
query EdlynProductTemplate($originalId: String!) {
  datoCmsEdlynProduct(originalId: {eq: $originalId}) {
    seoMetaTags {
      tags
    }
    originalId
    jsonLd
    meta {
      publishedAt
    }
    title
    brand
    permalink
    gallery {
      ...InternalAssetProps
    }
    sku
    size
    availableIn {
      label
      url {
        ... on DatoCmsEdlynProduct {
          id
          title
          permalink
        }
        ... on DatoCmsBoneProduct {
          id
          title
          permalink
        }
        ... on DatoCmsWoodsProduct {
          id
          title
          permalink
        }
        ... on DatoCmsGreenwheatProduct {
          id
          title
          permalink
        }
      }
    }
    richContent {
      value
    }
    ingredients {
      value
    }
    nutritionalInformation {
      label
      value
    }
    tableColumnTitleOne
    tableColumnTitleTwo
    nutritionalTable {
      label
      serveValue
      perHundredValue
    }
    allergens
    directionsStorage {
      label
      value
      richValue {
        value
      }
    }
    instructionalVideo {
      ...ExternalAssetProps
    }
    related {
      title
      brand
      slug
      permalink
      header
      size
      gallery {
        ...InternalAssetProps
      }
    }
    freeSample
    blocks {
      __typename
      ...ProductCtaProps
    }
  }
  productForm: datoCmsForm(title: {eq: "Product Enquiry"}) {
    ...FormProps
  }
  productCta: datoCmsSingleProductCta(brand: {eq: "edlyn"}) {
    brand
    buttons {
      ...LinkWithTitleProps
    }
    title
    image {
      ...InternalAssetProps
    }
  }
}
`
export default EdlynProduct
